import React from 'react';
import { useTranslation } from 'react-i18next';
import { FieldErrors, FieldValues, Path, RegisterOptions, UseFormRegister } from 'react-hook-form-new';

import { TextInput } from 'components';
import { MIN_TEXT_INPUT_LENGTH, MAX_USER_NAME_LENGTH } from 'global-constants';

type UserNameInputProps<TFieldValues extends FieldValues = FieldValues> = {
    register: UseFormRegister<TFieldValues>;
    defaultValue?: string | number;
    errors: FieldErrors;
    label?: string;
    name: Path<TFieldValues>;
    maxLength?: number;
    isRequired: boolean;
};

export const TextFieldInput = <TFieldValues extends FieldValues = FieldValues>(
    props: UserNameInputProps<TFieldValues>
) => {
    const { register, errors, isRequired, label, name, defaultValue, maxLength = MAX_USER_NAME_LENGTH } = props;
    const [t] = useTranslation('validation');
    const error = errors[name];
    const getOptions: RegisterOptions<TFieldValues, Path<TFieldValues>> | undefined = {
        minLength: {
            value: MIN_TEXT_INPUT_LENGTH,
            message: 'validation:min-length',
        },
        maxLength: {
            value: maxLength,
            message: 'validation:max-length',
        },
        required: {
            value: isRequired,
            message: 'validation:required-field',
        },
    };
    return (
        <div className="top-space-3x">
            <TextInput
                label={label}
                defaultValue={defaultValue}
                id={name}
                errorMessage={t(error?.message as string, {
                    maxLength: maxLength,
                    minLength: MIN_TEXT_INPUT_LENGTH,
                })}
                reg={register(name, { ...getOptions })}
            />
        </div>
    );
};
